import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { IndependentIraUser, IndependentIraUserRequest } from 'services/requests';
import { useQueryParams } from 'hooks/routes';
import { Parameters } from 'constants/queryParameters';
import { QueryKeys } from 'constants/queryKeys';
import { MutationKeys } from 'constants/mutationKeys';
import { Messages } from 'constants/messages';
import { showInfoToast } from 'components/Toast';

export const useEditIndependentIraUser = () => {
  const queryClient = useQueryClient();
  const iraUserId = useQueryParams(Parameters.independentIraUserId);

  const mutate = async (payload: Partial<IndependentIraUserRequest>) => {
    const { data } = await api.editIndependentIraUser(iraUserId, payload);

    return data;
  };

  const mutationKey = MutationKeys.editIraUser;

  return useMutation<
    IndependentIraUser,
    AxiosError<ApiError>,
    Partial<IndependentIraUserRequest>
  >(mutationKey, mutate, {
    onSuccess: (data) => {
      queryClient.invalidateQueries([QueryKeys.profileList, data.email]);
      queryClient.invalidateQueries(QueryKeys.independentIraUsers);
      queryClient.invalidateQueries([QueryKeys.independentIraUser, iraUserId]);
      showInfoToast(Messages.saveChanges);
    },
  });
};
